import React from "react";
import { motion } from "framer-motion";

export default function About() {
  return (
    <div className="min-h-screen pt-32 pb-24 hero-gradient noise" data-testid="about-page">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <p className="section-label">Our Story</p>
          <h1 className="font-display text-5xl md:text-7xl tracking-tighter mt-4 leading-[0.95]">
            The <em className="text-gradient-gold not-italic">spice trade</em>,<br />rebuilt from scratch.
          </h1>
        </motion.div>
        <div className="mt-14 space-y-8 text-cream/80 text-lg leading-relaxed max-w-3xl">
          <p>For 500 years, the global spice trade has concentrated power in the hands of middlemen. Farmers earn 3% of retail. Buyers pay 300% premiums. Quality is unverifiable.</p>
          <p>WorldFoods2U exists to break that cycle. Every farmer on our platform is verified by origin. Every listing carries a grade, a certification trail, a harvest date. Every buyer pays into escrow, holds the goods before releasing funds.</p>
          <p>Anonymous by design — buyers see the brand, not the hand. This protects origin premiums, ensures quality fair-play, and lets farmers scale without politics.</p>
          <p className="font-display text-3xl text-cream not-italic">Origin to Market. In fourteen days.</p>
        </div>
      </div>
    </div>
  );
}
